import I18n from 'I18n';
import { Set as ImmutableSet } from 'immutable';
import BranchAccordion from 'automation-ui-canvas/containers/flow-views/test-flow/simulation/BranchAccordion';
import WalmartFilterBranchRenderer from 'flow-doctor-lib/components/filters/WalmartFilterBranchRenderer';
import ObjectNameReference from 'automation-ui-enrollment/components/filters/enrollment/generic-enrollment-table/ObjectNameReference';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import ListSegmentationFilters from 'automation-ui-enrollment/components/common/ListSegmentationFilters';
import UnpredictableBranchOverrideView from 'automation-ui-canvas/containers/flow-views/test-flow/simulation/UnpredicatbleBranchOverrideView';
import BranchOverrideView from 'automation-ui-canvas/containers/flow-views/test-flow/simulation/BranchOverrideView';
import ListBranchActionSummary from 'automation-ui-action-features/actions/list-branch/ListBranchActionSummary';
import { useHistory } from 'react-router-dom';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ListBranchActionPreview = ({
  logEvent,
  flow,
  recordId,
  viewData,
  branchOverrideValue,
  setBranchOverrideValue
}) => {
  var _alertContext$unsuppo;
  const history = useHistory();
  const action = logEvent.action;
  const connection = action.getConnection();
  const debugResults = logEvent.contextMap.LIST_DEBUG_EVALUATION_RESULTS;
  const acceptedListId = logEvent.contextMap.ACCEPTED_LIST_ID;
  const {
    flowAlerts
  } = viewData.alerts;
  const alert = flowAlerts.find(flowAlert => flowAlert.actionId === action.actionId && flowAlert.id === 'UNSUPPORTED_LIST_BRANCH_ALERT');
  const alertContext = alert === null || alert === void 0 ? void 0 : alert.context;
  const isUnpredictableBranch = alertContext === null || alertContext === void 0 ? void 0 : alertContext.isUnpredictableBranch;
  const unsupportedBranches = (_alertContext$unsuppo = alertContext === null || alertContext === void 0 ? void 0 : alertContext.unsupportedBranches) !== null && _alertContext$unsuppo !== void 0 ? _alertContext$unsuppo : ImmutableSet();
  if (connection.getBranches().isEmpty()) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isUnpredictableBranch ? /*#__PURE__*/_jsx(UnpredictableBranchOverrideView, {
      marginBlock: "300",
      marginInlineEnd: "300",
      flow: flow,
      event: logEvent,
      branchOverrideValue: branchOverrideValue,
      setBranchOverrideValue: setBranchOverrideValue
    }) : /*#__PURE__*/_jsx(BranchOverrideView, {
      marginBlockEnd: "300",
      marginInlineEnd: "300",
      flow: flow,
      event: logEvent,
      branchOverrideValue: branchOverrideValue,
      setBranchOverrideValue: setBranchOverrideValue
    }), /*#__PURE__*/_jsx("div", {
      className: "m-y-3",
      children: /*#__PURE__*/_jsx(ListBranchActionSummary, {
        action: action,
        flowObjectTypeId: flow.objectTypeId
      })
    }), connection.getBranches().map((branch, index) => {
      const listId = branch.listId;
      const isUnsupportedBranch = listId && unsupportedBranches.has(listId);
      return /*#__PURE__*/_jsx(BranchAccordion, {
        branchName: branch.getBranchName() || I18n.text('action-features.list-branch.branch-label.default', {
          branchNumber: index + 1
        }),
        iconStyle: listId && !isUnsupportedBranch ? debugResults[listId].debugFilterBranch.acceptedStatus : 'DEFERRED',
        isAcceptedBranch: !isUnpredictableBranch && acceptedListId === listId,
        children: isUnsupportedBranch && alert ? /*#__PURE__*/_jsxs("div", {
          className: "m-all-3",
          children: [/*#__PURE__*/_jsx("p", {
            className: "m-bottom-1",
            children: alert.getMessage({
              viewData,
              flow,
              history
            })
          }), /*#__PURE__*/_jsx(ListSegmentationFilters, {
            headerNode: null,
            objectTypeId: flow.objectTypeId,
            readOnly: true,
            value: branch.filterBranch,
            openInEditMode: false
          })]
        }) : !!branch.filterBranch && !!listId && /*#__PURE__*/_jsx("div", {
          className: "m-bottom-3",
          children: /*#__PURE__*/_jsx(WalmartFilterBranchRenderer, {
            objectTypeId: flow.objectTypeId,
            debugOptions: {
              filterBranch: debugResults[listId].debugFilterBranch,
              displayMode: 'ALL'
            },
            filterBranch: branch.filterBranch,
            filterWidthType: "DEFAULT",
            bordered: false,
            padded: false,
            fallbackFilterElement: /*#__PURE__*/_jsx(ListSegmentationFilters, {
              headerNode: null,
              objectTypeId: flow.objectTypeId,
              readOnly: true,
              value: branch.filterBranch,
              openInEditMode: false
            })
          })
        })
      }, index);
    }), /*#__PURE__*/_jsx(BranchAccordion, {
      branchName: connection.getDefaultBranchName() || I18n.text('action-features.list-branch.branch-label.otherwiseDefaultBranchName'),
      iconStyle: isUnpredictableBranch ? 'DEFERRED' : 'REJECTED',
      isAcceptedBranch: !isUnpredictableBranch && acceptedListId === undefined,
      children: acceptedListId === undefined && !isUnpredictableBranch ? /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation.testV2.simulatePanel.branch.defaultContinue",
        options: {
          recordTitle: /*#__PURE__*/_jsx(ObjectNameReference, {
            objectTypeId: flow.objectTypeId,
            id: recordId
          })
        }
      }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation.testV2.simulatePanel.branch.noneMetReject",
        options: {
          recordTitle: /*#__PURE__*/_jsx(ObjectNameReference, {
            objectTypeId: flow.objectTypeId,
            id: recordId
          })
        }
      })
    }), isUnpredictableBranch && /*#__PURE__*/_jsx(View, {
      marginBlock: "200",
      children: /*#__PURE__*/_jsx(Text, {
        as: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.testV2.simulatePanel.branch.chooseAScenario"
        })
      })
    })]
  });
};
export default ListBranchActionPreview;